import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import { useHistory } from 'react-router-dom';

import WebGalleryHeaderContainer from '../../containers/WebGalleryHeaderContainer';
import AccountCardConfigurator from '../../../../services/cards/views/AccountCardConfigurator';
import { getAsset } from '../../../../util/assets';

const WebGalleryAccountCards = () => {
  const history = useHistory();

  const onExit =
    history.length > 1 ? history.goBack : () => history.push('/galleries');

  return (
    <Fragment>
      <Helmet>
        <title>Send a card &ndash; Waldo</title>
        <body className="body-web-gallery-account-cards" />
      </Helmet>

      <WebGalleryHeaderContainer />

      <div className="web-gallery-account-card-wrap">
        <AccountCardConfigurator onExit={onExit} />

        <img
          src={getAsset('/confetti-transparent.png')}
          alt="Confetti"
          className="web-gallery-account-card-confetti"
        />
      </div>
    </Fragment>
  );
};

export default WebGalleryAccountCards;
